// @ts-nocheck

class TestimonialsContent extends HTMLElement {
    constructor() {
        super();
        this.currentPage = 1;
        this.handle = this.getAttribute('data-product-handle');
        this.paginationCount = this.getAttribute('data-pagination-count');
        this.data;
        this.isInited = false;
        this.showMoreBtn = this.querySelector('[show-more-testimonials]');
        this.writeReviewBtn = this.querySelector('[write-review]');
        this.testimonialsCount = 0;

        // Set API info based on dev or production store
        if (Shopify.shop === Theme.store.dev_url_judgeme) {
            this.storeUrl = Theme.store.dev_url_judgeme;
            this.apiKey = Theme.store.dev_api_key_judgeme;
        } else {
            this.storeUrl = Theme.store.production_url_judgeme;
            this.apiKey = Theme.store.production_api_key_judgeme;
        }

        this.showMoreBtn.addEventListener('click', () => this.fetchReviews());
        this.initWriteReviewTrigger();

        // When there are no reviews yet, the collapsible button should open
        // Judge.me's native "write a review" form instead of the (empty) drawer.
        // Registered on the capture phase so it runs before <custom-drawer>'s own
        // click listener on this same button, regardless of upgrade order.
        this.addEventListener('click', (e) => {
            if (!this.isInited || Number(this.testimonialsCount) > 0) return;
            if (!e.target.closest('[testimonials-drawer-trigger]')) return;

            e.preventDefault();
            e.stopImmediatePropagation();
            this.openNativeWriteReview();
        }, true);
    }

    connectedCallback() {
        this.fetchReviews();
    }

    initWriteReviewTrigger() {
        const setup = () => {
            const jdgmBtn = document.querySelector('.jdgm-write-rev-link');

            if (!jdgmBtn) return false;

            this.jdgmWriteReviewBtn = jdgmBtn;

            // Make sure it's visible
            this.writeReviewBtn.classList.remove('hidden');

            // Attach your trigger
            this.writeReviewBtn.addEventListener('click', () => this.openNativeWriteReview());

            return true;
        };

        // 1. Try immediately (in case it's already in DOM)
        if (setup()) return;

        // 2. Watch for it if not yet loaded
        const observer = new MutationObserver(() => {
            if (setup()) {
                observer.disconnect(); // stop once found
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    openNativeWriteReview() {
        const jdgmBtn = this.jdgmWriteReviewBtn || document.querySelector('.jdgm-write-rev-link');
        if (!jdgmBtn) return;

        setTimeout(() => jdgmBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true })), 50);
    }

    async fetchReviews() {
        const url = `https://judge.me/api/v1/widgets/product_review?shop_domain=${this.storeUrl}&api_token=${this.apiKey}&handle=${this.handle}&page=${this.currentPage}&per_page=${this.paginationCount}`;
        console.log(url)

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const data = await response.json();
            
            this.data = data.widget;
            const dataDiv = document.createElement('div');
            dataDiv.innerHTML = this.data;

            if(!this.isInited){
                this.setReviewNumber(dataDiv);
                this.isInited = true;
            }

            const testimonials = dataDiv.querySelectorAll('.jdgm-rev');

            if (testimonials.length === 0) {
                this.showMoreBtn?.remove();
                return;
            }

            testimonials.forEach(testimonial => {
                this.createTestimonial(testimonial);
            });

            this.currentPage = this.currentPage + 1;

            const currentTestimonialCount = this.querySelectorAll('.testimonial').length;
            const isLastPage = testimonials.length < Number(this.paginationCount);

            if(isLastPage || currentTestimonialCount >= this.testimonialsCount){
                this.showMoreBtn?.remove();
            }

        } catch (err) {
            console.error('Error fetching Judge.me reviews:', err);
        }
    }

    createTestimonial(testimonial) {
        const template = document.querySelector('#testimonial-template');
        const container = document.querySelector('#customer-testimonials');

        if (!template || !container) return;

        // Clone template
        const clone = template.content.cloneNode(true);

        // === DATA EXTRACTION ===
        const authorEl = testimonial.querySelector('.jdgm-rev__author');
        const dateEl = testimonial.querySelector('.jdgm-rev__timestamp');
        const textEl = testimonial.querySelector('.jdgm-rev__body');
        const ratingEl = testimonial.querySelector('.jdgm-rev__rating');

        const author = authorEl?.textContent?.trim() || '';
        const rating = ratingEl?.getAttribute('data-score') || 0;

        let dateFormatted = '';
        if (dateEl) {
            const rawDate = dateEl.getAttribute('data-content');
            dateFormatted = rawDate?.split(' ')[0] || '';
        }

        const text = textEl?.textContent?.trim() || '';

        // === INJECT INTO TEMPLATE ===
        clone.querySelector('[testimonial-author-info]').textContent = author;
        clone.querySelector('[testimonial-date]').textContent = dateFormatted;
        clone.querySelector('[testimonial-text]').textContent = text;
        this.applyRatingStars(clone.querySelector('.testimonial-stars'), rating);

        // === APPEND ===
        container.appendChild(clone);
    }

    applyRatingStars(container, rating) {
        if (!container) return;

        const value = parseFloat(rating) || 0;
        const stars = container.querySelectorAll('.icon-star');

        stars.forEach((star, index) => {
            const fill = Math.max(0, Math.min(1, value - index)) * 100;
            star.style.setProperty('--star-fill', `${fill}%`);
        });
    }

    setReviewNumber(dataDiv){
        const testimonialsCountEl = this.querySelector('[testimonials-count]');
        const testimonialsCountText = testimonialsCountEl.getAttribute('data-testimonials-text');
        const writeReviewText = testimonialsCountEl.getAttribute('data-write-review-text');
        const widget = dataDiv.querySelector('.jdgm-rev-widg');
        const testimonialsCount = widget?.getAttribute('data-number-of-reviews') || 0;
        const averageRating = widget?.getAttribute('data-average-rating') || 0;
        this.testimonialsCount = testimonialsCount;

        const hasReviews = Number(testimonialsCount) > 0;
        this.classList.toggle('no-reviews', !hasReviews);

        testimonialsCountEl.textContent = hasReviews
            ? `${testimonialsCount} ${testimonialsCountText}`
            : writeReviewText;

        this.applyRatingStars(this.querySelector('.testimonials-collapsible-extra .testimonial-stars'), averageRating);

        // The testimonials drawer (and everything inside it) gets moved out of
        // <testimonials-content> by ProductInformation.moveDrawers(), so these
        // elements must be looked up globally rather than via `this.querySelector`.
        const averageRatingEl = document.querySelector('[testimonials-average-rating]');
        const testimonialsNumberEl = document.querySelector('[testimonials-number]');

        if (averageRatingEl) {
            averageRatingEl.textContent = (Math.round(parseFloat(averageRating) * 10) / 10) || 0;
        }

        if (testimonialsNumberEl) {
            testimonialsNumberEl.textContent = testimonialsCount;
        }
    }
}

if (!customElements.get('testimonials-content')) {
    customElements.define('testimonials-content', TestimonialsContent);
}